import { useGenericSelector } from "../../Shared/Redux";
import { IApiCallState } from "../ApiCalls/Models";
import { hydrateApiCallState } from "../ApiCalls/Utils";
import { Direction, IAvalilableTableTimes, IBookingTravelSummary, IPassengerType, IPaymentData, IServiceInformation, IStop, IVoucher } from "../Models";


export const getApiCallState = () => hydrateApiCallState(useStateSelector(state => state.apicalls));
export function useStateSelector<T>(selectorFunc: (state: IManageBookingAppState) => T) { return useGenericSelector((state :IManageBookingAppState) => selectorFunc(state)); }

export interface IManageBookingAppState
{
	manageBooking: IManageBookingState,
	apicalls: IApiCallState
}

export interface IManageBookingState
{
	hideSearchForm?: boolean;
	bookingNumber?: string;
	email?: string;
	mode?: "" | "PaymentOnly";
	booking?: IBooking;
	services?: IServiceInformation[];
	passengerTypes?: IPassengerType[];
	authToken?: { accessToken: string; expires: string; }
	payment?: IPaymentData;
	vouchers?: IVoucher[];
	discountCodes?: IVoucher[];
	showCancelModal?: boolean;
}

export interface IBooking
{
	isProvisional: boolean;
	hasPendingChanges: boolean;
	bookingNumber: string;
	created: string;
	totalPrice: number;
	totalPriceToBePaid: number;
	payments?: IPayment[];
	outbound?: IBookingTravelSummary;
	inbound?: IBookingTravelSummary;
	customer?: ICustomer;
	passengers: IPassenger[];
	vouchers?: IVoucher[];
	discountCodes?: IVoucher[];
	cancelled: boolean;
	canBeCancelled: boolean;
	canBeReverted: boolean;
	paidWithVoucherAmount: number;
	refundedVoucherAmount: number;
	isRefundable: boolean; // = betala tillbaka som PENGAR
	tableBooking?: {
		availableTimes?: { [segmentId: string]: IAvalilableTableTimes[] };
		bookings?: ITableBooking[];
	}
	// tableBookings?: ITableBooking[],
	options?: any;
	availableOptions?: IAvailableOptionsForBooking;
	canRequestCompensation: boolean;
}

export interface IAvailableOptionsForBooking
{
	segments: {
		segment: IOptionSegment;
		options: IAvailableOption[];
	}[];
}

export interface IOptionSegment
{
	id: string;
	origin: IStop;
	destination: IStop;
	departureDate: string;
	direction: "outward"|"return";
}

export interface IAvailableOption
{
	name: string;
	code: string;
	tariffCode: string;
	description: string;
	maxQuantity: number;
	maxQuantityOption: "UN"|"GS"|"SA"|"AI"|"AC";
	price: number;
}


export interface IPayment
{
	id: string;
	provider?: string;
	method?: string;
	amount: number;
}

export interface IPassenger
{
	id: string;
	type: string;
	firstName?: string;
	lastName?: string;
	email?: string;
}

export interface ICustomer
{
	firstName?: string;
	lastName?: string;
	email?: string;
	phoneNumber?: string;
}

export interface ITableBooking
{
	slot: string;
	type?: string;
	segmentId: string;
	direction?: Direction;
	bookingId: number;
	time: string;
	persons: number;
	date: string;
	isNew?: boolean;
	temporary?: boolean;
}